import { z } from 'zod';

export type CalculateFestivalEssDto = z.infer<
  typeof calculateFestivalEssDtoSchema
>;

const scoreObject = z.object({
  score: z.number(),
  maxScore: z.number(),
});

export const calculateFestivalEssDtoSchema = z.object({
  score: z.number(),
  maxScore: z.number(),
  topics: z.object({
    PARITY_EQUALITY: z.object({
      score: z.number(),
      maxScore: z.number(),
      sections: z.object({
        ARTISTIC_TEAM: scoreObject,
        PERMANENT_OPERATIONAL_TEAM: scoreObject,
        OCCASIONAL_OPERATIONAL_TEAM: scoreObject,
        TRANSPARENCY_MANAGEMENT: scoreObject,
      }),
    }),
    ACCESSIBILITY_SOCIAL_DIALOGUE: z.object({
      score: z.number(),
      maxScore: z.number(),
      sections: z.object({
        ACCESSIBILITY: scoreObject,
        RISK_PREVENTION: scoreObject,
        VOLUNTEERS: scoreObject,
        COMMUNICATION: scoreObject,
        TEAM_MANAGEMENT: scoreObject,
      }),
    }),
    LOCAL_IMPACT_RSE_ENGAGEMENT: z.object({
      score: z.number(),
      maxScore: z.number(),
      sections: z.object({
        LOCALITY_EMPLOYMENT_PARTNERS: scoreObject,
        ECONOMIC_SOCIAL_IMPACT: scoreObject,
      }),
    }),
  }),
  sectors: z.object({
    artists: z.object({
      score: z.number(),
      maxScore: z.number(),
    }),
    public: z.object({
      score: z.number(),
      maxScore: z.number(),
    }),
    site: z.object({
      score: z.number(),
      maxScore: z.number(),
    }),
    team: z.object({
      score: z.number(),
      maxScore: z.number(),
    }),
  }),
});
